import { AppConfig } from './app-config.model';

export const env: AppConfig = {
    tradgineDataUrl: 'https://data.tradgine.com',
    auctionFlowUrl: 'https://af.tradgine.com',
    auctionSealedFlowUrl: 'https://afs.tradgine.com',
    authUrl: 'https://auth.tradgine.com/api',
    autoBidUrl: 'https://bid.tradgine.com',
    notificationsUrl: 'https://notifications.tradgine.com',
    historyUrl: 'https://history.tradgine.com',
    bidReportingHubUrl: 'https://notifications.tradgine.com/bidReportingHub',
    sealedBidReportingHubUrl: 'https://notifications.tradgine.com/sealedBidReportingHub',
    auctionReportingHubUrl: 'https://notifications.tradgine.com/auctionReportingHub',
    tradingProcedureStatusReportingHubUrl: 'https://notifications.tradgine.com/tradingProcedureStatusReportingHub',
    environment: 'Development',
};
